import { RadioGroup, RadioGroupItem, Typography } from "@suraasa/placebo-ui"
import { Answer as AnswerType } from "api/resources/assessments/types"
import clsx from "clsx"

import styles from "../MultipleCorrect/MultipleCorrect.module.css"

type Props = {
  question: AnswerType
}

function SingleCorrect({ question }: Props) {
  return (
    <>
      <div>
        <Typography variant="body" className="mb-2 mt-1">
          {question.question}
        </Typography>
      </div>
      <div className="mt-2">
        <div>
          <RadioGroup>
            {Object.entries(question.options).map(([optionId, optionText]) => {
              const isCorrect = question.response
                ? question.isCorrect &&
                  question.response[0] === parseInt(optionId)
                : false
              const isMarked = question.response
                ? parseInt(optionId) === question.response[0]
                : false

              return (
                <RadioGroupItem
                  key={optionId}
                  containerClass={clsx(
                    "flex w-full flex-row items-center gap-1 rounded-lg p-1 text-smallBody",
                    {
                      [styles.correctAnswer]: isCorrect,
                      [styles.markedAnswer]: !isCorrect && isMarked,
                    }
                  )}
                  value=""
                  readOnly
                  label={optionText}
                  color={isCorrect ? "success" : "critical"}
                  checked={isCorrect || isMarked}
                />
              )
            })}
          </RadioGroup>
        </div>
      </div>
    </>
  )
}

export default SingleCorrect
